import { render, staticRenderFns } from "./IconSvgGraduate.vue?vue&type=template&id=0ccbf26e&scoped=true&"
import script from "./IconSvgGraduate.vue?vue&type=script&lang=js&"
export * from "./IconSvgGraduate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccbf26e",
  null
  
)

export default component.exports